/**
 * active Select2 library
 */

/**
 *  fiter events
 */
jQuery(document).ready(function ($) {
    // Toggle сворачивания фильтра
    $('#show_filter').on('click', function () {
        const $btn = $(this);
        const $content = $('#filter_content');

        // Тоглим классы
        $btn.toggleClass('active');
        $content.toggleClass('is-open');
        
        // Опционально: сохраняем состояние в localStorage, если нужно
    });


    function moveGlider() {
        const $container = $('.tabs-filter');
        const $activeInput = $container.find('input:checked');
        // Получаем активное значение
        const activeFilterValue = $activeInput.val();
        $container.removeClass('past future').addClass(activeFilterValue);
        const $activeLabel = $activeInput.closest('.tab-item');
        const $glider = $container.find('.tab-glider');

        if ($activeLabel.length) {
            // Получаем позицию и ширину активного лабеля
            const labelPos = $activeLabel.position();
            const labelWidth = $activeLabel.outerWidth();

            // Устанавливаем координаты глайдера
            $glider.css({
                'left': labelPos.left + 'px',
                'width': labelWidth + 'px'
            });
        }
    }

    // Запуск
    $(document).ready(moveGlider);
    $('.tabs-filter input').on('change', moveGlider);

    const $form = $('#events-filter-form');
    const $grid = $('#events-response');
    const $pagination = $('#events-paginate');

    // Функция сбора данных и отправки запроса
    function getFilteredEvents(page = 1) {
        // // Собираем все данные формы в объект
        // let formData = $form.serializeArray();
        
        // // Добавляем обязательные параметры для AJAX
        // formData.push({ name: 'action', value: 'filter_events' });
        // formData.push({ name: 'paged', value: page });

        // // Обновляем URL в браузере (как в твоих новостях), чтобы можно было скопировать ссылку
        // let stateUrl = window.location.pathname + '?' + $form.serialize();
        
        // window.history.pushState({ path: stateUrl }, '', stateUrl);

        // 1. Собираем массив данных формы
        let formData = $form.serializeArray();
        let cleanParams = [];

        // 2. Фильтруем: оставляем только заполненные поля
        $.each(formData, function(i, field) {
            if (field.value.trim() !== '') {
                // Сохраняем как есть (category[] останется со скобками)
                cleanParams.push(field.name + '=' + encodeURIComponent(field.value));
            }
        });

        // 3. Формируем строку запроса (без пустых полей)
        let queryString = cleanParams.join('&');

        // 4. Формируем путь (пагинация)
        let currentPath = window.location.pathname.replace(/\/page\/\d+\/?$/, '');
        if (page > 1) {
            // Убедимся, что путь заканчивается на слэш перед page
            currentPath = currentPath.replace(/\/$/, '') + '/page/' + page + '/';
        }

        // 5. Финальный URL для браузера
        let stateUrl = currentPath + (queryString ? '?' + queryString : '');

        // Обновляем историю
        window.history.pushState({ path: stateUrl }, '', stateUrl);
        $.ajax({
            url: globalurl + "/wp-admin/admin-ajax.php", // Убедись, что переменная локализована через wp_localize_script
            type: 'POST',
            data: queryString + '&action=filter_events&paged=' + page,
            // data: formData,
            beforeSend: function() {
                // console.log('ajax beforeSend...', queryString);
                $('#events-grid-wrap').find('.preloader-wrapper').addClass('active');
                $grid.addClass('loading').css('opacity', '0.5');

                $grid.html('');
                $pagination.html('');

                $('html, body').animate({ scrollTop: $grid.offset().top - 100 }, 800);
            },
            success: function(res) {
                // console.log('ajax success:', res);
                if (res.success) {
                    // Плавно обновляем контент
                    $grid.html(res.data.html).css('opacity', '1').removeClass('loading');
                    $pagination.html(res.data.pagination);
                }
                $('#events-grid-wrap').find('.preloader-wrapper').removeClass('active');
            }
        });

    }

    // Слушаем клики по леблам категории
    $('#events-grid-wrap').on('click', '.js-category-label', function(e) {
        const isDesktop = window.matchMedia('(min-width: 992px)').matches;
        const filterExists = $('#show_filter').length > 0;

        if (isDesktop && filterExists) {
            e.preventDefault();

            // Теперь берем slug из атрибута data-name
            const categorySlug = $(this).data('name'); 
            
            // Находим нужный чекбокс по его значению
            const $targetCheckbox = $('.checkbox-list input[name="category[]"][value="' + categorySlug + '"]');

            if ($targetCheckbox.length > 0) {
                // 1. Снимаем галочки со всех категорий (если нужен одиночный выбор)
                $('.checkbox-list input[name="category[]"]').prop('checked', false);

                // 2. Ставим галочку на нужную
                $targetCheckbox.prop('checked', true);

                // 3. ТРИГГЕР: заставляем фильтр сработать
                // 'change' обычно вешается на чекбоксы для запуска AJAX
                $targetCheckbox.trigger('change');

                // console.log('Фильтр категории переключен на: ' + categorySlug);
                
                // Опционально: можно плавно проскроллить пользователя к началу сетки,
                // чтобы он увидел, что результаты начали обновляться
                /*
                $('html, body').animate({
                    scrollTop: $(".events-grid-wrap").offset().top - 100
                }, 500);
                */
            } else {
                console.warn('Чекбокс с value="' + categorySlug + '" не найден в фильтре.');
            }
        }
    });
    // Слушаем клики по леблам языка и формата
    $('#events-grid-wrap').on('click', '.js-ev-format-label', function(e) {
        // 1. Проверяем условия (Desktop + наличие кнопки фильтра)
        const isDesktop = window.matchMedia('(min-width: 992px)').matches;
        const filterExists = $('#show_filter').length > 0;
        if (isDesktop && filterExists) {
            // Останавливаем стандартный переход по ссылке, если лейбл обернут в <a>
            e.preventDefault();
            const categoryName = $(this).data('name');
            const $searchInput = $('input[name="search"]');

            if ($searchInput.length > 0) {
                // Вставляем значение и триггерим изменения
                $searchInput.val(categoryName).trigger('input').focus();
                
                // console.log('Поиск обновлен через AJAX-родителя: ' + categoryName);
            }
        }
    });

    // Слушаем клики по табам, чекбоксам и ввод в поиск
    $form.on('change', 'input[type="radio"], input[type="checkbox"]', function(e) {
        getFilteredEvents(1); // При смене фильтра — всегда 1-я страница

        toggleClearButton();
    });

    //Обработка Enter в поле поиска
    $form.on('keydown', 'input[name="search"]', function(e) {
        if (e.which == 13) { // Если нажат Enter
            const searchTerm = $(this).val().trim();
            
            if (searchTerm.length > 0 && searchTerm.length < 3) {
                e.preventDefault(); // Запрещаем действие
                return false;       // Выходим из функции
            }
            
            // Если символов достаточно, можно либо ничего не делать (таймер сработает сам),
            // либо принудительно вызвать поиск, отменив таймер:
            clearTimeout(searchTimer);
            getFilteredEvents(1);
        }
    });
    // Для поиска добавим небольшую задержку (debounce), чтобы не слать запрос на каждую букву
    let searchTimer;
    $form.on('input', 'input[name="search"]', function() {
        const searchTerm = $(this).val().trim(); // Убираем пробелы
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function() {
            // Если введено 1 или 2 символа — игнорируем (не шлем запрос для поиска)
            // Но если поле очистили совсем (0 символов) — вызываем фильтр, чтобы сбросить поиск
            if (searchTerm.length > 0 && searchTerm.length < 3) {
                return; 
            }
            
            getFilteredEvents(1);
        }, 700);
    });

    // Обработка клика по пагинации (AJAX пагинация)
    $(document).on('click', '#events-paginate a', function(e) {
        e.preventDefault();
        // Вытаскиваем номер страницы из ссылки
        let url = $(this).attr('href');
        let page = url.match(/page\/(\d+)/) ? url.match(/page\/(\d+)/)[1] : 1;
        
        getFilteredEvents(page);
        
        // Скролл к началу сетки
        // $('html, body').animate({ scrollTop: $grid.offset().top - 100 }, 500);
    });

    // Отменяем стандартную отправку формы по нажатию Enter в поиске
    $form.on('submit', function(e) {
        e.preventDefault();
        getFilteredEvents(1);
    });



    // Обработчик клика на "Clear"
    function toggleClearButton() {
        const hasChecked = $('input[name="category[]"]:checked').length > 0;
        if(hasChecked){
            $('#clear-category').addClass('is-visible');
        }else{
            $('#clear-category').removeClass('is-visible');
        }
    }
    $('#clear-category').on('click', function (e) {
        e.preventDefault();

        const $form = $('#events-filter-form');
        const $checkboxes = $form.find('input[name="category[]"]');

        // 1. Проверяем, есть ли что очищать (чтобы не спамить запросами)
        if ($checkboxes.filter(':checked').length === 0) return;

        // 2. Снимаем галочки со всех категорий
        $checkboxes.prop('checked', false);

        // 3. Запускаем твою функцию получения ивентов (сброс на 1 страницу)
        if (typeof getFilteredEvents === 'function') {
            getFilteredEvents(1);
        } else {
            // Если функция не глобальная, просто триггерим change на форме
            $form.trigger('change');
        }
        setTimeout(()=>{
            toggleClearButton();
        },0)
        // console.log('Categories cleared');
    });
    // Запускаем при загрузке страницы и после каждого AJAX
    $(document).ready(toggleClearButton);



    /**
     * блок search
     */
        const $searchInput = $('input[name="search"]');
        const $clearSearch = $('#clear-search');
        if($searchInput.length>0 && $clearSearch.length>0){
            // 1. Функция управления видимостью кнопки
            function toggleSearchClear() {
                if ($searchInput.val().trim().length > 0) {
                    $clearSearch.addClass('is-visible');
                } else {
                    $clearSearch.removeClass('is-visible');
                }
            }

            // Запускаем проверку при загрузке (если в инпуте уже есть текст)
            toggleSearchClear();

            // Следим за вводом
            $searchInput.on('input', function() {
                toggleSearchClear();
            });

            // 2. Клик по кнопке очистки
            $clearSearch.on('click', function (e) {
                e.preventDefault();
                
                // Очищаем поле
                $searchInput.val('');
                
                // Скрываем кнопку
                toggleSearchClear();
                
                // Фокусируемся обратно на поиске (удобно для пользователя)
                $searchInput.focus();

                // Запускаем фильтрацию (так как поле пустое, AJAX вернет всё)
                if (typeof getFilteredEvents === 'function') {
                    getFilteredEvents(1);
                } else {
                    $searchInput.trigger('change');
                }
            });
        }
    /**
     * блок search
     */
});
